import { Displaying, Positioning } from "@bonusx-global/bx-design-system";
import { SparkleSolid, SparklesSolid } from "@bonusx-global/bx-icons";
import Box from "@mui/material/Box";
import anime from "animejs";
import { useEffect, useRef } from "react";
import { ZERO_DIGIT } from "../../../../../constants/env";
import type { IAiChatbotIconProps } from "./ai-chatbot-icon.interface";

export function AiChatbotIcon({ animated = false, loop = false }: Readonly<IAiChatbotIconProps>): JSX.Element {
  const containerRef = useRef<SVGSVGElement>(null);

  useEffect(
    function animateSvg() {
      if (animated && containerRef.current) {
        anime({
          targets: containerRef.current,
          duration: 1000,
          opacity: [0, 1],
          scale: [0, 1.2, 1],
          easing: "cubicBezier(.5, .05, .1, .3)",
          loop,
        });
      }
    },
    [animated, loop]
  );

  if (!animated) {
    return <SparklesSolid />;
  }

  return (
    <Box display={Displaying.inline} lineHeight={ZERO_DIGIT}>
      <SparkleSolid />
      <Box position={Positioning.absolute} lineHeight={ZERO_DIGIT} sx={{ top: 8 }} ref={containerRef}>
        <SparklesSolid />
      </Box>
    </Box>
  );
}
